import {Box, Theme, Typography} from '@mui/material'
import {SystemStyleObject} from '@mui/system/styleFunctionSx/styleFunctionSx'
import React from 'react'

export const Tag: React.FC<{
  label: string
  descriptionSx?: SystemStyleObject<Theme>
  'data-test-id'?: string
  children: React.ReactNode
}> = ({children, label, descriptionSx = {}, ...props}) => {
  return (
    <Box
      sx={{
        width: '100%',
        whiteSpace: 'pre-line'
      }}
      data-test-id={props['data-test-id']}
    >
      <Typography variant="caption">{label}</Typography>
      <Typography
        variant="h4"
        color="textPrimary"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: 16,
          fontWeight: 500,
          ...descriptionSx
        }}
      >
        {children}
      </Typography>
    </Box>
  )
}
